function parseCookies(cookieHeader) {
	const cookies = {};
	if (!cookieHeader) return cookies;

	cookieHeader.split(';').forEach(cookie => {
		const [name, ...rest] = cookie.trim().split('=');
		if (name && rest.length) {
			cookies[name] = decodeURIComponent(rest.join('='));
		}
	});
	return cookies;
}

module.exports = {
	parseCookies
};